import selectHasRight from "astrid-permissions/selectors/selectHasRight";

import { useProfile } from "../../authentication/state/profile";
import { useOrganizationId } from "../../organizations/state/organizationId";

import useHasRole from "./useHasRole";

const dev_ignorePermissions = [
	// "articles.view",
	// "productions.manage"
	// "productions.settings.level2",
	// "productions.settings.level3",
	// "productions.settings.level4",
];

export default function useHasRight() {
	const profile = useProfile();
	const orgId = useOrganizationId();
	const hasRole = useHasRole();

	const hasRight = selectHasRight(profile, orgId);

	return (right, checkRole = true) => {
		if (dev_ignorePermissions.includes(right)) {
			return false;
		}

		// Special case for publisher Bookea (hide reader registry)
		if (right === "readers.view" && orgId === "KUbqZ3OYu3nS9FkaLoYo") {
			return false;
		}

		return (checkRole && hasRole("owner", "admin")) || hasRight(right);
	};
}
